module.exports = __webpack_public_path__ + "static/slide-2-4e3e92a4cd7fbfe1991d31d4e9748d50.jpg";